import { Business } from '../../types/Business';
import { BusinessSummary } from '../../types/BusinessSummary';
import { BusinessSummaryRequest } from '../../types/requests/BusinessSummaryRequest';

export abstract class IBusinessSummaryService {
  abstract getBusinessSummary(
    businessSummaryRequest: BusinessSummaryRequest,
  ): Promise<BusinessSummary>;
  abstract leaveBusiness(businessId: string): Promise<BusinessSummary>;
  abstract getAllClientBusinesses(): Promise<Business[]>;
  abstract getClientBusinessById(clientId: string): Promise<Business>;
}
